import { drawAvwapAlarm } from './drawAvwapAlarm.js'

// A zero-width render-only suffix identifies each label even when names match.
// It is never stored in the user's AVWAP name.
export const avwapAlarmLabelTitle = (name, index) => name + '\u2063'.repeat(index + 1)

// LWC 5.2 exposes no final collision-adjusted label coordinate. Observe only
// registered title paints on this chart's own 2D contexts, after native layout.
// No library-private fields, global prototype changes, timers or pixel reads.
// The 5/12 outer padding and digit-normalized metrics match its price-axis
// renderer; keep the real-renderer collision/resize smoke when upgrading LWC.
export class AvwapLabelAlarmRenderer {
  constructor(container) {
    this.container = container
    this.entries = new Map()
    this.contexts = new Map()
    this.sync()
    this.observer = new MutationObserver(() => this.sync())
    this.observer.observe(container, { childList: true, subtree: true })
  }
  setEntries(entries) { this.entries = entries }
  sync() {
    const current = new Set([...this.container.querySelectorAll('canvas')].map(c => c.getContext('2d')).filter(Boolean))
    for (const [ctx, hooks] of this.contexts) if (!current.has(ctx)) {
      if (ctx.fillText === hooks.wrapped) ctx.fillText = hooks.original
      this.contexts.delete(ctx)
    }
    for (const ctx of current) if (!this.contexts.has(ctx)) {
      const original = ctx.fillText
      const renderer = this
      function wrapped(text, x, y, ...rest) {
        const result = original.call(this, text, x, y, ...rest)
        const color = renderer.entries.get(text)
        if (color && this.textAlign === 'right' && this.textBaseline === 'middle') {
          const metrics = this.measureText(String(text).replace(/[2-9]/g, '0'))
          const fontSize = Number(this.font.match(/([\d.]+)px/)?.[1]) || 12
          const left = x - Math.ceil(metrics.width) - fontSize * 5 / 12
          const centerY = y - ((metrics.actualBoundingBoxAscent || 0) - (metrics.actualBoundingBoxDescent || 0)) / 2
          if (left >= 16) drawAvwapAlarm(this, left - 10, centerY, color)
        }
        return result
      }
      ctx.fillText = wrapped
      this.contexts.set(ctx, { original, wrapped })
    }
  }
  destroy() {
    this.observer.disconnect()
    for (const [ctx, hooks] of this.contexts) if (ctx.fillText === hooks.wrapped) ctx.fillText = hooks.original
    this.contexts.clear()
    this.entries.clear()
  }
}
